import { InvoicingModelModel } from 'src/app/models/invoicing/invoicing-model.model';
import { TaxModel } from '../management/tax.model';
export class InvoicingModelDetailModel {
  invoicingModelDetailId: number = 0;
  invoicingModelId: number = 0;
  invoicingModel: InvoicingModelModel = new InvoicingModelModel();
  conceptInvoicingId: number = 0;
  alterConcept: string | null = null;
  swAiu: boolean = false;
  invoiceNumber: number = 0;
  saleAccount: string | null = null;
  saleDevolutionAccount: string | null = null;
  ivaTaxId: number = 0;
  ivaTax: TaxModel = new TaxModel();
  rtfTaxId: number = 0;
  rtfTax: TaxModel = new TaxModel();
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}